import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getSecuLeverageThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_LEVERAGE',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getLeverage(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadLeverage = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_LEVERAGE',
  async (data) => {
    const response = await FinancialAnalysisService.downloadLeverage(data)
    handleExport(response.data, response.filename)
  },
)
